
/* ===== inline script block ===== */

document.querySelectorAll('.faq-item__q').forEach(function(b){
  b.addEventListener('click',function(){b.closest('.faq-item').classList.toggle('open')});
});


/* ===== inline script block ===== */

/* ---------- Year ---------- */
document.getElementById('yr').textContent = new Date().getFullYear();

/* ---------- Header: yellow over hero, white after scroll ---------- */
(function(){
  const header=document.querySelector('.header');
  const hero=document.querySelector('.hero');
  if(!header) return;
  function onScroll(){
    const threshold=hero ? Math.max(hero.offsetHeight-header.offsetHeight,60) : 60;
    header.classList.toggle('is-scrolled', window.scrollY > threshold);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
})();


/* ---------- Hero mobile slider (auto-rotate) ---------- */
const heroTrack=document.getElementById('heroTrack');
if(heroTrack){
  const heroDots=document.querySelectorAll('#heroDots span');
  let heroI=0;
  setInterval(()=>{heroI=(heroI+1)%heroDots.length;heroTrack.scrollTo({left:heroTrack.clientWidth*heroI,behavior:'smooth'})},4000);
  heroTrack.addEventListener('scroll',()=>{
    const i=Math.round(heroTrack.scrollLeft/heroTrack.clientWidth);
    heroI=i;heroDots.forEach((d,idx)=>d.classList.toggle('is-active',idx===i));
  });
}

/* ---------- Mobile nav drawer (slides from left) ---------- */
const menuToggle=document.getElementById('menuToggle'),mobileNav=document.getElementById('mobileNav');
const navOverlay=document.getElementById('navOverlay'),navClose=document.getElementById('navClose');
function openNav(){mobileNav.classList.add('open');navOverlay.classList.add('open');menuToggle.setAttribute('aria-expanded',true)}
function closeNav(){mobileNav.classList.remove('open');navOverlay.classList.remove('open');menuToggle.setAttribute('aria-expanded',false)}
menuToggle.addEventListener('click',openNav);
navClose.addEventListener('click',closeNav);
navOverlay.addEventListener('click',closeNav);
mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeNav));
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeNav()});

/* ---------- Mobile search toggle ---------- */
const searchToggle=document.querySelector('.search-toggle'),searchBox=document.querySelector('.search');
const searchBack=document.querySelector('.search__back');
function closeSearch(){searchBox.classList.remove('search--open')}
searchToggle.addEventListener('click',()=>{const o=searchBox.classList.toggle('search--open');if(o)searchBox.querySelector('input').focus()});
if(searchBack)searchBack.addEventListener('click',closeSearch);
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeSearch()});

/* ---------- Product data (placeholders) ---------- */
const bestSellers=[
  {name:'Surti Laziz',grams:'300g',cat:'Special',title:'Surti Laziz',now:399,was:539,desc:'Rich, indulgent Surti-style delight',badge:'NEW LAUNCH',flag:true,rating:'4.8',rc:'64',img:'product%20image/plain/Surti%20Laziz%20Black-and-Gold%20Pouch.png',hov:'hover%20images/Surti%20Laziz.jpg'},
  {name:'Cheese Angoori',grams:'250g',cat:'Main Course',title:'Cheese Angoori',now:349,was:461,desc:'Soft cheese angoori in creamy gravy',badge:'BESTSELLER',flag:true,rating:'4.9',rc:'71',img:'product%20image/plain/Cheese%20Angoori%20Stand-Up%20Pouch.png',hov:'hover%20images/Cheese%20Angoori.jpg'},
  {name:'Cheese Gotalo',grams:'250g',cat:'Main Course',title:'Cheese Gotalo',now:299,was:399,desc:'Cheesy paneer gotalo, rich & indulgent',badge:'HOT DROP',rating:'4.8',rc:'95',img:'product%20image/plain/Surti%20Flavour%20Cheese%20Gotalo%20Pouch.png',hov:'hover%20images/Cheese%20Gotalo.jpg'},
  {name:'Chole Chana',grams:'250g',cat:'Main Course',title:'Chole Chana',now:199,was:266,desc:'Hearty chole chana, rich & homestyle',badge:'STREET CLASSIC',rating:'4.8',rc:'96',img:'product%20image/plain/Surti%20Flavour%20Chole%20Chana%20Pouch.png',hov:'hover%20images/Chole%20Chana.jpg'},
  {name:'Gajar Halwo',grams:'200g',cat:'Sweets',title:'Gajar Halwo',now:229,was:344,desc:'Slow-cooked carrot halwa with ghee & nuts',badge:'GHAR JAISA',rating:'4.8',rc:'53',img:'product%20image/plain/Surti%20Flavour%20Gajar%20Halwa%20Pouch.png',hov:'hover%20images/Gajar%20Halwa.jpg'},
  {name:'Surti Locho',grams:'200g',cat:'Street Food',title:'Surti Locho',now:249,was:333,desc:'Steamed, layered locho with butter & sev',flag:true,rating:'4.9',rc:'188',img:'product%20image/plain/Surti%20Cheese%20Locho%20Instant%20Meal%20Pouch.png',hov:'hover%20images/Cheese%20Locho.jpg'},
  {name:'Schezwan Rice',grams:'300g',cat:'Main Course',title:'Schezwan Rice',now:219,was:329,desc:'Surti-style schezwan rice, ready in minutes',badge:'BESTSELLER',benefit:'Ghee-Rich',rating:'4.8',rc:'143',img:'product%20image/plain/Surti%20Schezwan%20Rice%20Pouch.png',hov:'hover%20images/Jain%20Schezwan.jpg'},
  {name:'Surti Laziz',grams:'300g',cat:'Special',title:'Surti Laziz',now:399,was:543,desc:'Rich, indulgent Surti-style delight',badge:'MOST RE-ORDERED',benefit:'Street-Style',rating:'4.7',rc:'210',img:'product%20image/plain/Surti%20Laziz%20Black-and-Gold%20Pouch%20(1).png',hov:'hover%20images/Surti%20Laziz.jpg'},
  {name:'Rasawala Khaman',grams:'300g',cat:'Street Food',title:'Rasawala Khaman',now:169,was:226,desc:'Soft khaman soaked in spiced curry',badge:'HOT DROP',benefit:'Soft & Juicy',rating:'4.8',rc:'96',img:'product%20image/New%20folder/WhatsApp%20Image%202026-10-09%20at%202.34.36%20PM.jpeg',cover:true,cover:true},
  {name:'Paneer Butter Masala',grams:'250g',cat:'Main Course',title:'Paneer Butter Masala',now:249,was:337,desc:'Creamy tomato gravy with soft paneer',badge:'TOP RATED',benefit:'Rich & Creamy',rating:'4.8',rc:'175',img:'all%20products/Panner%20Butter%20Masala/1%20(1).jpg'},
  {name:'Surti Chat',grams:'250g',cat:'Street Food',title:'Surti Chat',now:199,was:271,desc:'Tangy street-style Surti chaat',badge:'BESTSELLER',benefit:'Tangy',rating:'4.7',rc:'120',img:'all%20products/Surat%20Chat/1%20(1).jpg'}
];
const combos=[
  {name:'Signature Trio',cat:'Combo',title:'Signature Trio',now:595,was:845,desc:'Our three signature bestsellers in one box.',badge:'TOP RATED',benefit:'Combo',rating:'4.9',rc:'120',img:'combo/combo-default2.jpg',hov:'combo/popart-trio-cream.jpg',cover:true},
  {name:'Homestyle Comfort',cat:'Combo',title:'Homestyle Comfort',now:649,was:945,desc:'A comforting spread of Surti homestyle favourites.',badge:'BESTSELLER',benefit:'Combo',rating:'4.8',rc:'88',img:'combo/combo-default2.jpg',hov:'combo/popart-trio-cream.jpg',cover:true},
  {name:'Surat Street Trio',cat:'Street Food',title:'Surat Street Trio',now:549,was:799,desc:'Three iconic Surat street-food dishes together.',badge:'STREET FOOD',benefit:'Combo',rating:'4.8',rc:'96',img:'combo/combo-default2.jpg',hov:'combo/popart-trio-cream.jpg',cover:true},
  {name:'Royal Feast',cat:'Combo',title:'Royal Feast',now:1199,was:1799,desc:'A grand multi-dish feast for the whole family.',badge:'FAMILY PACK',benefit:'Combo',rating:'4.8',rc:'53',img:'combo/combo-default2.jpg',hov:'combo/popart-trio-cream.jpg'},
  {name:'Indo-Chinese Combo',cat:'Combo',title:'Indo-Chinese Combo',now:699,was:999,desc:'Surti-style Indo-Chinese, ready in minutes.',badge:'NEW',benefit:'Combo',rating:'4.7',rc:'64',img:'combo/combo-default2.jpg',hov:'combo/popart-trio-cream.jpg'},
  {name:'Pure Jain Thali',cat:'Jain',title:'Pure Jain Thali',now:749,was:1099,desc:'A complete no onion, no garlic Jain thali.',badge:'JAIN',benefit:'Combo',rating:'4.9',rc:'77',img:'combo/combo-default2.jpg',hov:'combo/popart-trio-cream.jpg'}
];

function stars(){return '<span class="stars" aria-hidden="true">★★★★★</span>'}
function card(p){
  return `<article class="card reveal">
    <div class="card__media">
      <span class="card__tag chip">${p.tag}</span>
      <span class="card__avail">In stock</span>
      <div class="ph"><span>${p.shot}</span></div>
    </div>
    <div class="card__body">
      <div>
        <div class="card__name">${p.name}</div>
        <div class="card__guj">${p.guj}</div>
      </div>
      <div class="card__rating">${stars()} <span>[4.8] · [${(Math.floor(Math.random()*300)+80)}]</span></div>
      <div class="card__price"><span class="now">[₹${p.now}]</span><span class="was">[₹${p.was}]</span></div>
      <button class="btn btn--primary btn--block" data-add="${p.name}" data-price="${p.now}">Quick add +</button>
    </div>
  </article>`;
}
/* Product card */
const flagColors=[
  {bg:'#FCE500',fg:'#000'},   /* Bright Lemon */
  {bg:'#1eb473',fg:'#fff'},   /* Medium Jungle green */
  {bg:'#FCE500',fg:'#000'},   /* Bright Lemon */
  {bg:'#000000',fg:'#FCE500'},/* Black + yellow */
  {bg:'#1eb473',fg:'#fff'},   /* Medium Jungle green */
  {bg:'#000000',fg:'#FCE500'} /* Black + yellow */
];
function bsCard(p,i){
  const c=flagColors[i%flagColors.length];
  const disc=Math.round((p.was-p.now)/p.was*100);
  return `<article class="bs-card">
    <div class="bs-card__media${p.cover?' bs-card__media--bg':''}">
      ${p.flag?`<span class="bs-card__tag" style="background:${c.bg};color:${c.fg}"><span>${p.badge||'TOP RATED'}</span></span>`:''}
      ${p.img?`<img src="${p.img}" alt="${p.name}" loading="lazy">`:`<div class="ph"><span>${p.shot||p.name}</span></div>`}
      ${p.hover?`<img class="bs-card__hover" src="${p.hover}" alt="" aria-hidden="true" loading="lazy">`:''}
    </div>
    <div class="bs-card__body">
      <div class="bs-card__rating"><span class="rstars">★★★★★</span><span>(${p.rc||'120'})</span></div>
      <div class="bs-card__name">${p.title||p.name}</div>
      ${p.grams?`<p class="bs-card__meta"><span class="bs-card__meta-i">Rehyd. Wt. ${p.grams}</span></p>`:''}
      <div class="bs-card__pack">
        <span>Pack:</span>
        <div class="pack-opts">
          <button type="button" class="pack-opt is-active">1</button>
          <button type="button" class="pack-opt">2</button>
          <button type="button" class="pack-opt">3</button>
          <button type="button" class="pack-opt">4</button>
        </div>
      </div>
      <div class="bs-card__foot">
        <div class="bs-card__pricewrap">
          <div class="bs-card__price"><span class="now">₹${p.now}</span><span class="was">₹${p.was}</span><span class="bs-card__save">Save ${disc}%</span></div>
          
        </div>
        <button class="bs-card__add" data-add="${p.name}" data-price="${p.now}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>ADD</button>
      </div>
    </div>
  </article>`;
}
function bsCardAlt(p,i){
  const c=flagColors[i%flagColors.length];
  return `<article class="bs-card bs-card--alt">
    <div class="bs-card__media${p.cover?' bs-card__media--bg':''}">
      ${p.flag?`<span class="bs-card__tag" style="background:${c.bg};color:${c.fg}"><span>${p.badge||'TOP RATED'}</span></span>`:''}
      ${p.img?`<img src="${p.img}" alt="${p.name}" loading="lazy">`:`<div class="ph"><span>${p.shot||p.name}</span></div>`}
      ${p.hov?`<img class="bs-card__hov" src="${p.hov}" alt="" loading="lazy">`:''}
    </div>
    <div class="bs-card__body">
      <div class="bs-card__name">${p.title||p.name}</div>
      <div class="bsa-metarow"><p class="bs-card__meta"><span class="bs-card__meta-i">Rehyd. Wt. ${p.grams||'250g'}</span></p><div class="bsa-rating"><span class="rstars">★★★★★</span><span><span class="rc-n">${p.rc||'120'}</span> <span class="rc-w">reviews</span></span></div></div>
      <div class="bsa-price"><span class="now">Rs. ${p.now}</span><span class="was">Rs. ${p.was}</span></div>
      <div class="bsa-packs">
        <button type="button" class="bsa-pack is-active"><span class="pk-word">Pack Of </span><span class="pk-x">×</span>1</button>
        <button type="button" class="bsa-pack"><span class="pk-word">Pack Of </span><span class="pk-x">×</span>3</button>
        <button type="button" class="bsa-pack"><span class="pk-word">Pack Of </span><span class="pk-x">×</span>5</button>
      </div>
      <button class="bs-card__add" data-add="${p.name}" data-price="${p.now}">ADD TO CART<span class="cta-opts">3 options</span></button>
    </div>
  </article>`;
}
function bsCardAltCombo(p,i){
  const c=flagColors[i%flagColors.length];
  return `<article class="bs-card bs-card--alt bs-card--combo">
    <div class="bs-card__media bs-card__media--bg">
      ${p.flag?`<span class="bs-card__tag" style="background:${c.bg};color:${c.fg}"><span>${p.badge||'TOP RATED'}</span></span>`:''}
      ${p.img?`<img src="${p.img}" alt="${p.name}" loading="lazy">`:`<div class="ph"><span>${p.shot||p.name}</span></div>`}
      ${p.hov?`<img class="bs-card__hov" src="${p.hov}" alt="" loading="lazy">`:''}
    </div>
    <div class="bs-card__body">
      <div class="bs-card__name">${p.title||p.name}</div>
      <div class="bsa-metarow"><div class="bsa-rating"><span class="rstars">★★★★★</span><span><span class="rc-n">${p.rc||'120'}</span> <span class="rc-w">reviews</span></span></div></div>
      <div class="bsa-price"><span class="now">Rs. ${p.now}</span><span class="was">Rs. ${p.was}</span></div>
      <div class="bsa-packs">
        <button type="button" class="bsa-pack is-active"><span class="pk-word">Pack Of </span><span class="pk-x">×</span>1</button>
        <button type="button" class="bsa-pack"><span class="pk-word">Pack Of </span><span class="pk-x">×</span>3</button>
        <button type="button" class="bsa-pack"><span class="pk-word">Pack Of </span><span class="pk-x">×</span>5</button>
      </div>
      <button class="bs-card__add" data-add="${p.name}" data-price="${p.now}">ADD TO CART<span class="cta-opts">3 options</span></button>
    </div>
  </article>`;
}
const wshTrack=document.getElementById('wshTrack');
if(wshTrack){
  const wStep=()=>wshTrack.clientWidth*0.85;
  const _wp=document.getElementById('wshPrev'),_wn=document.getElementById('wshNext');
  if(_wp)_wp.addEventListener('click',()=>wshTrack.scrollBy({left:-wStep(),behavior:'smooth'}));
  if(_wn)_wn.addEventListener('click',()=>wshTrack.scrollBy({left:wStep(),behavior:'smooth'}));
}
const bsTrack=document.getElementById('bsTrack');
if(bsTrack){
  /* bsTrack cards are rendered by Liquid */
document.addEventListener('click',function(e){var b=e.target.closest('.bsa-pack');if(!b)return;var wrap=b.closest('.bsa-packs');if(!wrap)return;wrap.querySelectorAll('.bsa-pack').forEach(function(x){x.classList.remove('is-active')});b.classList.add('is-active');});

  const bsStep=()=>bsTrack.clientWidth*0.85;
  const _bp=document.getElementById('bsPrev'),_bn=document.getElementById('bsNext');
  if(_bp)_bp.addEventListener('click',()=>bsTrack.scrollBy({left:-bsStep(),behavior:'smooth'}));
  if(_bn)_bn.addEventListener('click',()=>bsTrack.scrollBy({left:bsStep(),behavior:'smooth'}));
}
const comboTrack=document.getElementById('comboTrack');
if(comboTrack){
  /* comboTrack cards are rendered by Liquid */
  const cbStep=()=>comboTrack.clientWidth*0.85;
  const _cp=document.getElementById('cbPrev'),_cn=document.getElementById('cbNext');
  if(_cp)_cp.addEventListener('click',()=>comboTrack.scrollBy({left:-cbStep(),behavior:'smooth'}));
  if(_cn)_cn.addEventListener('click',()=>comboTrack.scrollBy({left:cbStep(),behavior:'smooth'}));
}


const showTrack=document.getElementById('showTrack');
/* duplicate reels once for a seamless auto-scroll loop */
if(showTrack&&!showTrack.dataset.looped){showTrack.dataset.looped='1';showTrack.innerHTML+=showTrack.innerHTML;}
const pressTrack=document.getElementById('pressTrack');
if(pressTrack&&!pressTrack.dataset.looped){pressTrack.dataset.looped='1';pressTrack.innerHTML+=pressTrack.innerHTML;}

/* Hill's-style reviews carousel */
const hprReviews=[
  {title:"Excellent ready-to-eat food!",quote:"The taste is authentic, the ingredients feel fresh and the flavours are well-balanced. It tastes almost like home-cooked, with great variety and excellent value for money.",name:"Pari Prajapati",loc:"via Google",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.03%20PM.jpeg"},
  {title:"Fresh, tasty & convenient",quote:"The ready-to-eat food was fresh, tasty and very convenient. Quick to prepare — a great option for busy days when you want a satisfying meal.",name:"Nemisha Vadodariya",loc:"via Google",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.09%20PM.jpeg"},
  {title:"Superb Pav Bhaji",quote:"Amazing experience with Surti food. I tried their Pav Bhaji — superb flavour with perfect balance.",name:"Ronak Kavathiya",loc:"via Google",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.06%20PM.jpeg"},
  {title:"Top-tier quality",quote:"The quality of their ready-to-eat meals is top-tier — the Surti Laziz and Aakha Kanda were absolute standouts and tasted incredibly fresh.",name:"Asmita",loc:"via Google",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.05%20PM.jpeg"},
  {title:"Just like home food",quote:"Taste is amazing and they have almost everything. Tried the paneer sabji — mesmerising. You don't miss your home food, that's for sure.",name:"Nikunj Patel",loc:"via Google",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.04%20PM.jpeg"},
  {title:"So many options",quote:"Loved how many options they have. Super convenient for quick meals, and the food actually tastes great. Definitely worth it.",name:"Krupal Lathiya",loc:"via Google",img:"videos/WhatsApp%20Image%202026-06-16%20at%204.52.07%20PM.jpeg"}
];
const hprStar='<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M12 3.2l2.55 5.17 5.7.83-4.13 4.02.97 5.68L12 16.2l-5.09 2.68.97-5.68L3.75 9.22l5.7-.83z"/></svg>';
function hprCardHTML(r){
  return `<article class="hpr-card">
    <div class="hpr-card__media"><img src="${r.img}" alt="" loading="lazy"></div>
    <div class="hpr-card__text">
      <div class="hpr-card__stars">${hprStar.repeat(5)}</div>
      <h3 class="hpr-card__title">${r.title}</h3>
      <p class="hpr-card__quote">${r.quote}</p>
      <div class="hpr-card__name">${r.name}<small>${r.loc}</small></div>
    </div>
  </article>`;
}
const hprTrack=document.getElementById('hprTrack');
if(hprTrack){
  hprTrack.innerHTML=hprReviews.map(hprCardHTML).join('');
  const hprStep=()=>hprTrack.clientWidth*0.85;
  document.getElementById('hprPrev').addEventListener('click',()=>hprTrack.scrollBy({left:-hprStep(),behavior:'smooth'}));
  document.getElementById('hprNext').addEventListener('click',()=>hprTrack.scrollBy({left:hprStep(),behavior:'smooth'}));
}


/* ---------- Visual cart ---------- */
var cart=(function(){try{return JSON.parse(localStorage.getItem('surtiflavour_cart'))||[]}catch(e){return[]}})();
const drawer=document.getElementById('drawer'),overlay=document.getElementById('overlay');
const cartCount=document.getElementById('cartCount'),cartTotal=document.getElementById('cartTotal');
const drawerItems=document.getElementById('drawerItems'),drawerEmpty=document.getElementById('drawerEmpty');
const toast=document.getElementById('toast');
let toastTimer;

function openCart(){drawer.classList.add('open');overlay.classList.add('open');drawer.setAttribute('aria-hidden','false')}
function closeCart(){drawer.classList.remove('open');overlay.classList.remove('open');drawer.setAttribute('aria-hidden','true')}
document.getElementById('cartOpen').addEventListener('click',openCart);
document.getElementById('cartClose').addEventListener('click',closeCart);
overlay.addEventListener('click',closeCart);
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart()});

function showToast(msg){toast.textContent=msg;toast.classList.add('show');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toast.classList.remove('show'),1800)}

function render(){
  try{localStorage.setItem('surtiflavour_cart',JSON.stringify(cart))}catch(e){}
  const count=cart.reduce((n,i)=>n+i.qty,0);
  const total=cart.reduce((s,i)=>s+i.qty*i.price,0);
  cartCount.textContent=count;
  cartTotal.textContent='₹'+total;
  if(!cart.length){drawerItems.innerHTML='';drawerItems.appendChild(drawerEmpty);drawerEmpty.style.display='';return}
  drawerEmpty.style.display='none';
  drawerItems.innerHTML=cart.map((i,idx)=>`
    <div class="ci">
      <div class="ci__thumb">${i.img?`<img src="${i.img}" alt="${i.name}">`:''}</div>
      <div class="ci__info">
        <div class="ci__name">${i.name}</div>
        <div class="ci__meta">${i.meta||'Ready-to-eat'}</div>
        <div class="ci__price">₹${i.price} <span class="each">/ pack · ₹${i.price*i.qty} total</span></div>
        <div class="qty">
          <button aria-label="Decrease" data-dec="${idx}">−</button>
          <span>${i.qty}</span>
          <button aria-label="Increase" data-inc="${idx}">+</button>
        </div>
      </div>
      <button class="ci__rm" aria-label="Remove" data-rm="${idx}">×</button>
    </div>`).join('');
}
function add(name,price,img,meta){
  const ex=cart.find(i=>i.name===name);
  if(ex)ex.qty++;else cart.push({name,price:Number(price),qty:1,img:img||'',meta:meta||''});
  render();showToast(name+' added ✓');
}

/* ---------- Mobile pack picker sheet ---------- */
(function(){
  var sheet=document.getElementById('psheet'),ov=document.getElementById('psheetOverlay'),grid=document.getElementById('psheetGrid'),title=document.getElementById('psheetTitle');
  if(!sheet)return;
  function openSheet(cta){
    var card=cta.closest('.bs-card');
    var name=cta.dataset.add, base=Number(cta.dataset.price);
    var imgEl=card?card.querySelector('.bs-card__media img'):null; var img=imgEl?imgEl.getAttribute('src'):'';
    var wtEl=card?card.querySelector('.bs-card__meta-i'):null; var wt=wtEl?wtEl.textContent.replace(/net\s*wt\.?\s*/i,'').trim():'';
    title.textContent=name+' \u2014 choose a pack';
    var packs=[{q:1,d:0},{q:3,d:.08},{q:5,d:.12}];
    grid.innerHTML=packs.map(function(p){
      var was=base*p.q, now=Math.round(was*(1-p.d)), per=Math.round(now/p.q);
      return '<div class="popt">'+
        '<div class="popt__media">'+
          (p.d?'<span class="popt__off">'+Math.round(p.d*100)+'% OFF</span>':'')+
          (img?'<img class="popt__img" src="'+img+'" alt="">':'')+
          '<button class="popt__add" data-pname="'+name+' (Pack of '+p.q+')" data-pprice="'+now+'" data-pimg="'+img+'">ADD</button>'+
        '</div>'+
        '<div class="popt__name">Pack of '+p.q+'</div>'+
        (wt?'<div class="popt__wt">'+wt+(p.q>1?' \u00d7 '+p.q:'')+'</div>':'')+
        '<div class="popt__price"><span class="n">\u20b9'+now+'</span>'+(p.d?'<span class="w">\u20b9'+was+'</span>':'')+'</div>'+
        '<div class="popt__per">\u20b9'+per+'/pack</div>'+
      '</div>';
    }).join('');
    sheet.classList.add('open'); ov.classList.add('open'); sheet.setAttribute('aria-hidden','false');
  }
  function closeSheet(){sheet.classList.remove('open');ov.classList.remove('open');sheet.setAttribute('aria-hidden','true');}
  document.getElementById('psheetClose').addEventListener('click',closeSheet);
  ov.addEventListener('click',closeSheet);
  grid.addEventListener('click',function(e){var b=e.target.closest('.popt__add');if(!b)return;add(b.dataset.pname,b.dataset.pprice,b.dataset.pimg,'Ready-to-eat');closeSheet();openCart();});
  document.addEventListener('click',function(e){
    if(window.innerWidth>600)return;
    var cta=e.target.closest('.bs-card--alt .bs-card__add');
    if(!cta)return;
    e.preventDefault();e.stopImmediatePropagation();
    openSheet(cta);
  },true);
})();

render();
document.addEventListener('click',e=>{
  const a=e.target.closest('[data-add]');
  if(a){
    const card=a.closest('.bs-card');
    const imgEl=card?card.querySelector('.bs-card__media img'):null;
    const catEl=card?card.querySelector('.bs-card__cat'):null;
    add(a.dataset.add,a.dataset.price,imgEl?imgEl.getAttribute('src'):'',catEl?catEl.textContent.trim():'');
    openCart();return}
  const mt=e.target.closest('.reel__mute');
  if(mt){const v=mt.parentElement.querySelector('video');if(v){v.muted=!v.muted;if(!v.muted)v.play();mt.style.opacity=v.muted?'1':'.55';}return}
  const pk=e.target.closest('.pack-opt');
  if(pk){pk.parentElement.querySelectorAll('.pack-opt').forEach(b=>b.classList.remove('is-active'));pk.classList.add('is-active');return}
  const inc=e.target.closest('[data-inc]');if(inc){cart[inc.dataset.inc].qty++;render();return}
  const dec=e.target.closest('[data-dec]');if(dec){const i=cart[dec.dataset.dec];i.qty--;if(i.qty<=0)cart.splice(dec.dataset.dec,1);render();return}
  const rm=e.target.closest('[data-rm]');if(rm){cart.splice(rm.dataset.rm,1);render();return}
});

/* ---------- Scroll reveal ---------- */
const io=new IntersectionObserver((entries)=>{
  entries.forEach(en=>{if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target)}})
},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* ---------- Rounded star icons in review cards ---------- */
(function(){
  const star='<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M12 3.2l2.55 5.17 5.7.83-4.13 4.02.97 5.68L12 16.2l-5.09 2.68.97-5.68L3.75 9.22l5.7-.83z"/></svg>';
  document.querySelectorAll('.rev-card__stars').forEach(s=>s.innerHTML=star.repeat(5));
})();

/* ---------- Count-up stats on scroll ---------- */
function countUp(el){
  const target=parseFloat(el.dataset.count),dec=parseInt(el.dataset.dec||'0'),suffix=el.dataset.suffix||'';
  const dur=1500,start=performance.now();
  (function step(now){
    const p=Math.min((now-start)/dur,1),eased=1-Math.pow(1-p,3),val=target*eased;
    el.textContent=(dec?val.toFixed(dec):Math.round(val))+suffix;
    if(p<1)requestAnimationFrame(step);else el.textContent=(dec?target.toFixed(dec):target)+suffix;
  })(start);
}
const statsSec=document.querySelector('.stats');
if(statsSec){
  const sObs=new IntersectionObserver((ents,o)=>{
    ents.forEach(e=>{if(e.isIntersecting){document.querySelectorAll('.stat b[data-count]').forEach(countUp);o.disconnect();}});
  },{threshold:.3});
  sObs.observe(statsSec);
}
const authSec=document.querySelector('.auth');
if(authSec){
  const aObs=new IntersectionObserver((ents,o)=>{
    ents.forEach(e=>{if(e.isIntersecting){authSec.querySelectorAll('.auth__num[data-count]').forEach(countUp);o.disconnect();}});
  },{threshold:.3});
  aObs.observe(authSec);
}

/* ---------- Footer accordions (mobile) ---------- */
document.querySelectorAll('.footer__col-head').forEach(function(btn){
  btn.addEventListener('click',function(){
    if(window.innerWidth>640) return;              // accordion only on phones
    var col=btn.closest('.footer__col');
    var open=col.classList.toggle('open');
    btn.setAttribute('aria-expanded', open);
  });
});


/* ===== inline script block ===== */

/* Force muted videos to autoplay (covers strict autoplay policies) */
(function(){
  function play(v){try{v.muted=true;v.setAttribute("muted","");v.setAttribute("playsinline","");var p=v.play();if(p&&p.catch)p.catch(function(){});}catch(e){}}
  function kick(){document.querySelectorAll("video").forEach(play);}
  if(document.readyState!=="loading")kick();else document.addEventListener("DOMContentLoaded",kick);
  window.addEventListener("load",function(){setTimeout(kick,200);setTimeout(kick,1000);});
  ["click","touchstart","scroll","keydown","mousemove"].forEach(function(ev){window.addEventListener(ev,kick,{once:true,passive:true});});
  if("IntersectionObserver" in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)play(e.target);});},{threshold:.2});document.querySelectorAll("video").forEach(function(v){io.observe(v);});}
})();


/* ===== inline script block ===== */

/* Link homepage cards to their product / combo pages */
(function(){
  function slugify(s){return (s||'').replace(/^Sp\.\s*/,'').trim().toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');}
  function wire(id,kind){
    var box=document.getElementById(id); if(!box) return;
    box.querySelectorAll('.bs-card').forEach(function(card){
      var h=card.querySelector('.bs-card__name'); if(!h) return;
      var slug=slugify(h.textContent); if(!slug) return;
      var href;
      if(kind==='combo'){ href=(slug==='signature-trio')?'combo-signature-trio.html':'combo-product.html?id='+slug; }
      else { href=(slug==='surti-locho')?'surti-cheese-locho.html':'product.html?id='+slug; }
      if(!h.querySelector('a')){h.innerHTML='<a href="'+href+'" style="color:inherit;text-decoration:none">'+h.textContent+'</a>';}
      var media=card.querySelector('.bs-card__media');
      if(media && !media.querySelector('a')){media.style.cursor='pointer';media.addEventListener('click',function(e){if(e.target.closest('.bs-card__add'))return;location.href=href;});}
    });
  }
  function run(){ wire('bsTrack','product'); wire('comboTrack','combo'); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
  setTimeout(run,300);
})();


/* ===== inline script block ===== */

/* Reel/video posters + play only when visible (stops blank video cards) */
(function(){
  var vids = Array.prototype.slice.call(document.querySelectorAll('video[src]'));
  vids.forEach(function(v){
    var src = v.getAttribute('src') || '';
    var base = decodeURIComponent(src.split('/').pop()).replace(/\.(mp4|mov|webm|m4v)$/i,'');
    if(base && !v.getAttribute('poster')){ v.setAttribute('poster','posters/'+base+'.jpg'); }
    try{ v.preload='metadata'; }catch(e){}
  });
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        var v=en.target;
        if(en.isIntersecting){ var p=v.play(); if(p&&p.catch){ p.catch(function(){}); } }
        else { try{ v.pause(); }catch(e){} }
      });
    }, {threshold:0.15});
    vids.forEach(function(v){ io.observe(v); });
  }
})();


/* ===== inline script block ===== */
(function(){try{var items=document.querySelectorAll(".faq-item");if(!items.length)return;var q=[];items.forEach(function(it){var qb=it.querySelector(".faq-item__q"),ab=it.querySelector(".faq-item__a");if(!qb||!ab)return;var qt=qb.textContent.replace(/\+\s*$/,"").trim(),at=ab.textContent.trim();if(qt&&at)q.push({"@type":"Question","name":qt,"acceptedAnswer":{"@type":"Answer","text":at}});});if(!q.length)return;var sc=document.createElement("script");sc.type="application/ld+json";sc.textContent=JSON.stringify({"@context":"https://schema.org","@type":"FAQPage","mainEntity":q});document.head.appendChild(sc);}catch(e){}})();

/* ===== inline script block ===== */
(function(){var t=document.getElementById("catsTrack");if(!t)return;function step(){return t.clientWidth*0.8;}var p=document.getElementById("catsPrev"),n=document.getElementById("catsNext");if(p)p.addEventListener("click",function(){t.scrollBy({left:-step(),behavior:"smooth"});});if(n)n.addEventListener("click",function(){t.scrollBy({left:step(),behavior:"smooth"});});})();

/* ===== inline script block ===== */
(function(){var t=document.getElementById('heroDTrack');if(!t)return;var prev=document.getElementById('heroDPrev'),next=document.getElementById('heroDNext'),dots=document.getElementById('heroDDots');function w(){return t.clientWidth;}function go(d){t.scrollBy({left:d*w(),behavior:'smooth'});}if(next)next.onclick=function(){go(1);};if(prev)prev.onclick=function(){go(-1);};t.addEventListener('scroll',function(){var i=Math.round(t.scrollLeft/w());if(dots){[].forEach.call(dots.children,function(s,k){s.classList.toggle('is-active',k===i);});}});var timer=setInterval(function(){var i=Math.round(t.scrollLeft/w());var n=(i+1)%t.children.length;t.scrollTo({left:n*w(),behavior:'smooth'});},6000);t.addEventListener('mouseenter',function(){clearInterval(timer);});})();

/* ===== inline script block ===== */
(function(){var p=(location.pathname.split("/").pop()||"").toLowerCase();if(!p)return;document.querySelectorAll(".nav a[href]").forEach(function(a){if((a.getAttribute("href")||"").toLowerCase()===p)a.setAttribute("aria-current","page");});})();
